import { SubscriptionClient } from "subscriptions-transport-ws"
import { createClient, fetchExchange, subscriptionExchange } from "urql"
import { GRAPHQL_SERVER_ENDPOINT, GRAPHQL_WS_SERVER_ENDPOINT } from "../constants"
import { cacheExchange } from "./exchanges"

const subscriptionClient = new SubscriptionClient(GRAPHQL_WS_SERVER_ENDPOINT, {
	reconnect: true,
})

export const urqlClient = createClient({
	url: GRAPHQL_SERVER_ENDPOINT,
	fetchOptions: { credentials: "include" },
	exchanges: [
		cacheExchange,
		fetchExchange,
		subscriptionExchange({
			forwardSubscription: (operation) => subscriptionClient?.request(operation) as any,
		}),
	],
})
